import { motion } from "framer-motion";
import { Scissors } from "lucide-react";

export default function CouponSection() {
  return (
    <section
      data-testid="coupon-section"
      className="py-24 md:py-32 bg-white relative overflow-hidden"
    >
      {/* Subtle gold ambient */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-gradient-to-b from-[#B76E79]/5 to-transparent blur-[100px] pointer-events-none" />

      <div className="max-w-4xl mx-auto px-6 md:px-12 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          {/* Coupon Card */}
          <div className="relative border border-[#EBEBEB] bg-white shadow-[0_20px_60px_rgba(0,0,0,0.06)]">
            {/* Top gold line */}
            <div className="h-[2px] gold-bg" />

            {/* Circular cutouts for coupon feel */}
            <div className="absolute -left-4 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-white border border-[#EBEBEB] z-10" />
            <div className="absolute -right-4 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-white border border-[#EBEBEB] z-10" />

            <div className="grid grid-cols-1 md:grid-cols-12 items-center">
              {/* Left: Discount */}
              <div className="md:col-span-4 p-6 md:p-12 text-center md:border-r md:border-dashed md:border-[#EBEBEB]">
                <p className="text-xs font-semibold uppercase tracking-[0.25em] gold-text mb-3">
                  Hoş Geldin Hediyesi
                </p>
                <div className="text-5xl sm:text-7xl font-bold tracking-tighter gold-text leading-none mb-2">
                  %25
                </div>
                <p className="text-sm font-medium text-gray-600 uppercase tracking-wider">
                  İndirim
                </p>
              </div>

              {/* Right: Details */}
              <div className="md:col-span-8 p-6 md:p-12">
                <h3
                  data-testid="coupon-headline"
                  className="text-2xl sm:text-3xl font-bold tracking-tight text-black mb-3 leading-tight"
                >
                  İlk Randevunuza Özel
                  <br />
                  <span className="gold-text">Hediye Kuponunuz</span>
                </h3>
                <p className="text-sm text-black/60 leading-relaxed mb-6 max-w-md">
                  Purevia Güzellik ailesine katılın! İlk randevunuzda tüm hizmetlerimizde geçerli %25 indirim fırsatını kaçırmayın.
                </p>

                {/* Code */}
                <div className="inline-flex items-center gap-4 bg-[#FAFAFA] border border-dashed border-[#B76E79]/40 px-6 py-3 mb-6">
                  <Scissors size={16} className="text-[#B76E79]" />
                  <div>
                    <p className="text-[10px] text-gray-400 uppercase tracking-widest">Kupon Kodu</p>
                    <p className="text-lg font-bold tracking-[0.15em] text-black">PUREVIA25</p>
                  </div>
                </div>

                <div className="flex flex-col sm:flex-row gap-3">
                  <a
                    href="https://wa.me/905441199544?text=Merhaba%2C%20PUREVIA25%20koduyla%20ilk%20randevuma%20%2525%20indirim%20almak%20istiyorum."
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="coupon-cta"
                    className="inline-flex items-center justify-center bg-black text-white hover:bg-gray-900 transition-colors duration-300 px-8 py-4 uppercase tracking-widest text-xs font-semibold"
                  >
                    Kuponu Kullan
                  </a>
                  <p className="text-xs text-gray-400 self-center">
                    WhatsApp'tan randevu alırken kodu belirtin
                  </p>
                </div>
              </div>
            </div>

            {/* Bottom gold line */}
            <div className="h-[2px] gold-bg" />
          </div>
        </motion.div>
      </div>
    </section>
  );
}
